var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"splash-screen"},[_c('div',{staticClass:"splash-screen__img-container"},[_c('LogoImage')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }